export default [
  {
    path: '/apps/pais/list',
    name: 'apps-pais-list',
    component: () => import('@/views/cadastros/gerais/pais/list/Index.vue'),
    meta: {
      pageTitle: 'País',
      resource: 'AdminHanes',
    },
  },
];
